import { MutationTree } from 'vuex'
import UserState from "@/store/modules/account/UserState"
import User from "@/types/account/user"
import store from '@/store'
import { AccountErrorTypes } from "@/store/modules/account/AccountErrorTypes"

export const mutations: MutationTree<UserState> = {
  setUser (state, payload) {
    state.user = payload as User
  },

  setUserFirstLogin (state, firstLogin) {
    if (state.user) {
      state.user.isFirstLogin = firstLogin
    }
  },

  setProfilePicture (state, profilePicture) {
    if (state.user) {
      state.user.profilePicture = profilePicture
    }
  },

  setCompanyLogo (state, companyLogo) {
    if (state.user) {
      state.user.companyLogo = companyLogo
    }
  },

  setCompanyColor (state, companyColor) {
    if (state.user) {
      state.user.companyColor = companyColor
    }
  },

  removeUser (state) {
    state.user = null
  },

  setAuthenticationError (state, payload) {
    if (payload) {
      const accountError = AccountErrorTypes.filter((error: any) => error.code === payload.code)
      if (accountError.length > 0) {
        state.authenticationError = accountError[0].value
      } else {
        store.dispatch('error/setError', payload.message)
      }
    } else {
      state.authenticationError = payload
    }
  }
}
